<template>
    <div class="w-768">

        <multi-lang-toggle :form="form"></multi-lang-toggle>

        <ol class="space-y-32">
            <li class="flex">
                <p>
                    {{ $t('site_editor.social.link.label') }}&nbsp;
                    <a
                        href="https://publish.twitter.com/#"
                        target="_blank"
                        class="font-semibold text-primary-60 underline"
                    >
                        {{ $t('site_editor.social.link.twitter') }}
                    </a>
                </p>
            </li>
            <li class="flex">
                <p>{{ $t('site_editor.social.text.twitter') }}</p>
            </li>
            <li class="flex flex-wrap">
                <div class="pt-4 mb-16">
                    <toggle v-model="transChecked">
                        {{ $t('site_editor.social.stepthree') }}
                    </toggle>
                </div>
                <div class="w-full">
                    <div v-show="transChecked">
                        <translatable #default="{ languages, selectedLanguage }" :errors="warningTabs" class="w-full">
                            <div v-for="lang in languages" :key="lang">
                                <simple-textarea
                                    v-show="lang === selectedLanguage"
                                    v-model="form.translated_url[lang]"
                                    autofocus
                                    class="w-full"
                                    :placeholder="placeholder"
                                >
                                    {{ $t('site_editor.social.steptwo') }} <span v-if="languages.length > 1">({{ lang }})</span>
                                </simple-textarea>
                            </div>
                        </translatable>
                    </div>

                    <simple-textarea
                        v-show="!transChecked"
                        v-model="form.url"
                        autofocus
                        class="w-full"
                        :placeholder="placeholder"
                    >
                        {{ $t('site_editor.social.steptwo') }}
                    </simple-textarea>
                </div>
            </li>
        </ol>

    </div>
</template>

<script>
import Translatable from '../forms/Translatable.vue';
import LanguagesMultiToggle from '../forms/LanguagesMultiToggle.vue';
import TextArea from '../forms/TextArea.vue';
import Toggle from '../forms/Toggle.vue';
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';

export default {
    components: {
        'translatable': Translatable,
        'multi-lang-toggle': LanguagesMultiToggle,
        'simple-textarea': TextArea,
        'toggle': Toggle,
    },
    data () {
        return {
            tmpTransUrls : {},
            transChecked: false,
            placeholder : '<a class="twitter-timeline" data-lang="nl" href="https://twitter.com/TwitterDev?ref_src=twsrc%5Etfw">Tweets by TwitterDev</a> <script async src="https://platform.twitter.com/widgets.js" charset="utf-8"/>'
        }
    },
    props: {
        form: {
            required: true,
        },
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        warningTabs() {
            let languages = this.currentCompany.jobsite.active_languages;
            let errorLang = [];

            for (let index in languages) {
                if (!this.form.data.translated_url[languages[index]] && this.form.data.published[languages[index]]) {
                    errorLang.push(languages[index]);
                }
            }
            return errorLang;
        },
    },
    created () {
        for (let lang of Object.keys(this.form.translated_url)) {
            this.tmpTransUrls[lang] = this.form.translated_url[lang];

            if (typeof this.form.translated_url[lang] === 'string') {
                this.transChecked = true;
            }
        }
    },
    watch: {
        transChecked (value, oldValue) {
            if (value) {
                //re-populate lang form inputs
                for (let lang of Object.keys(this.tmpTransUrls)) {
                    this.form.translated_url[lang] = this.tmpTransUrls[lang];
                }
            } else {
                //hold lang form inputs values and empty them
                for (let lang of Object.keys(this.form.translated_url)) {
                    this.tmpTransUrls[lang] = this.form.translated_url[lang];
                    this.form.translated_url[lang] = null;
                }
            }
        }
    }
}
</script>

<style scoped>
ol {
    counter-reset: step;
}

ol > li::before {
    counter-increment: step;
    content: counter(step);
    @apply flex-none text-white bg-primary rounded-32 w-24 h-24 leading-none flex items-center justify-center font-semibold mr-16;
}
</style>
